export const continueBtnCy = 'tel-your-story-continue-btn';
export const editIntroButtonDataSet = { cy: 'edit-button-intro' };
export const confirmDeleteButtonDataSet = { cy: 'confirm-delete-button-intro' };
